import { POST } from '@/shared/api/requests';

/**
 * Upload/save a photo for a layout
 */
export const saveLayoutPhoto = async (layoutId: string, photoFile: File): Promise<{ status: string; photo_url: string }> => {
  const formData = new FormData();
  formData.append('layout_id', layoutId);
  formData.append('photo', photoFile);

  const response = await POST('/layouts/save-photo/', formData);
  return response.data;
};


